/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Website_PriceInputs */

const et_plan_website_price = /** @type {(inputs: Plan_Website_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`900€`)
};

const en_plan_website_price = /** @type {(inputs: Plan_Website_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`900€`)
};

/**
* | output |
* | --- |
* | "900€" |
*
* @param {Plan_Website_PriceInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_website_price = /** @type {((inputs?: Plan_Website_PriceInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Website_PriceInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_website_price(inputs)
	return en_plan_website_price(inputs)
});